import Papa from "papaparse";
import { useState } from "react";
import toast from "react-hot-toast";
import { columnLabels } from "./CustomExport";

const CustomOnlyDownloadExport = ({
    fetchData,
    label = null,
    filename = "exported-data.csv",
    buttonClassname = "",
    defaultColumns = [],
    formatColumns = [],
    disableHover = false,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const fetchDataFunc = async () => {
        setIsLoading(true);
        const data = await fetchData();
        setIsLoading(false);

        downloadCSV(data || []);
    };

    const downloadCSV = (data = []) => {
        toast.dismiss();

        if (!data || !Array.isArray(data) || !data.length) {
            toast.error("Data not found");
            return;
        }

        let columns = defaultColumns?.length
            ? defaultColumns
            : Object.keys(data[0]);

        if (columns?.length == 0) {
            toast.error("please select some columns.", {
                id: "selectSomeColumns",
            });
            return;
        }

        const selectedData = data.map((row) => {
            const selectedRow = {};

            columns.forEach((column) => {
                let cellData = row[column];
                // Check if the cell data is an object
                if (typeof cellData === "object") {
                    // Convert object to string representation
                    // cellData = JSON.stringify(cellData);
                }

                //Timestampz to local string
                const isIsoTimestamp =
                    typeof cellData === "string" &&
                    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(cellData);
                if (isIsoTimestamp) {
                    try {
                        const date = new Date(cellData);
                        // Format to "dd/MM/yyyy, HH:mm:ss" in IST (Asia/Kolkata)
                        const formattedDate = date.toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: false,
                            timeZone: "Asia/Kolkata",
                        });

                        selectedRow[columnLabels[column] || column] =
                            formattedDate;
                        return;
                    } catch (e) {
                        selectedRow[columnLabels[column] || column] = cellData;
                        return;
                    }
                }

                if (column === "type" && formatColumns?.includes(column)) {
                    selectedRow[columnLabels[column] || column] =
                        cellData || "Order";
                } else if (
                    column === "voucher_date" &&
                    formatColumns.includes(column)
                ) {
                    selectedRow[columnLabels[column] || column] = cellData
                        ? new Date(cellData).toLocaleDateString()
                        : "N/A";
                } else if (
                    column === "voucher_no" &&
                    formatColumns.includes(column)
                ) {
                    console.log(cellData);
                    selectedRow[columnLabels[column] || column] =
                        cellData || "N/A";
                } else if (
                    column === "points" &&
                    formatColumns.includes(column)
                ) {
                    selectedRow[columnLabels[column] || column] =
                        cellData || "0.00";
                } else if (
                    column === "created_at" &&
                    formatColumns.includes(column)
                ) {
                    selectedRow[columnLabels[column] || column] = new Date(
                        cellData
                    ).toLocaleDateString();
                } else if (
                    column === "status" &&
                    filename == "cash_transactions"
                ) {
                    console.log("cash_transactions at export");
                    selectedRow[columnLabels[column] || column] =
                        cellData === "1"
                            ? "Success"
                            : cellData === "2"
                            ? "Pending"
                            : cellData === "0"
                            ? "Error"
                            : cellData;
                } else if (
                    column === "approval_status" &&
                    filename == "coupon_request_list"
                ) {
                    console.log("coupon_request_list at export");
                    selectedRow[columnLabels[column] || column] =
                        cellData === "1"
                            ? "Pending"
                            : cellData === "2"
                            ? "Accepted"
                            : cellData === "3"
                            ? "Rejected"
                            : cellData;
                } else if (
                    column === "approval_status" &&
                    filename == "cash_transfer_request_list"
                ) {
                    console.log("cash_transfer_request_list at export");
                    selectedRow[columnLabels[column] || column] =
                        cellData === "3"
                            ? "Pending"
                            : cellData === "1"
                            ? "Approved"
                            : cellData === "2"
                            ? "Rejected"
                            : cellData;
                } else if (column === "status") {
                    selectedRow[columnLabels[column] || column] =
                        cellData === "1"
                            ? "Active"
                            : cellData === "2"
                            ? "Inactive"
                            : cellData === "0"
                            ? "Deleted"
                            : cellData;
                } else if (column === "approval_status") {
                    selectedRow[columnLabels[column] || column] =
                        cellData === "1"
                            ? "Accepted"
                            : cellData === "2"
                            ? "Rejected"
                            : cellData === "3"
                            ? "Pending"
                            : cellData;
                } else {
                    selectedRow[columnLabels[column] || column] =
                        cellData || "N/A";
                }
            });

            return selectedRow;
        });

        const csv = Papa.unparse(selectedData);
        const name =
            filename +
            "-" +
            new Date().toISOString().replace(/:/g, "-").split("T")[0];
        const blob = new Blob([csv], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
        .color_shades;

    return (
        <button
            className={`transition ${buttonClassname}`}
            style={{
                transition: "all 0.2s",
            }}
            {...(disableHover
                ? {}
                : {
                      onMouseEnter: (e) => {
                          e.currentTarget.style.backgroundColor =
                              primaryColor["700"];
                          e.currentTarget.style.color = "white"; // optional: makes text readable
                      },
                      onMouseLeave: (e) => {
                          e.currentTarget.style.backgroundColor = "transparent";
                          e.currentTarget.style.color = "#374151"; // default Tailwind gray-700
                      },
                  })}
            onClick={() => {
                fetchDataFunc();
            }}
        >
            {isLoading ? "Please wait..." : label || "Download"}
        </button>
    );
};

export default CustomOnlyDownloadExport;
